import mutations from './mutations'
import inventory from '@/api/inventoryforms'

import { loadItemsBuilder, loadItemBuilder, saveItemBuilder, deleteItemBuilder } from '../crudFactory'
const apiEndpoint = 'inventoryforms'

export default {
  namespaced: true,

  state: {
    items: {},
    filters: null
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint }),
    loadItem: loadItemBuilder({ apiEndpoint }),
    saveItem: saveItemBuilder({ apiEndpoint }),
    deleteItem: deleteItemBuilder({ apiEndpoint }),
    saveArticles ({ rootState }, { inventoryId, item }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        inventory.saveArticles({ businessUnitId, inventoryId, item })
          .then(response => resolve(response))
      })
    },
    getInventoryList ({ rootState }, inventoryId) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        inventory.getInventoryList({ businessUnitId, inventoryId })
          .then(response => {
            resolve(response)
          })
      })
    },
    setFilters ({ commit, state }, filters) {
      return new Promise((resolve) => {
        commit('updateFilters', filters)
        resolve()
      })
    },
    getPdf ({ rootState }, inventoryId) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        inventory.getPDFList({ businessUnitId, inventoryId })
          .then(response => {
            resolve(response)
          })
          .catch(err => reject(err))
      })
    }
  },

  mutations: {
    ...mutations,
    updateFilters (state, filters) {
      state.filters = filters
    }
  }
}
